import { CaseFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";

import { fakeBlackListIdentifiers } from "./fakeBlackListIdentifier";
import {
  fakeEntreprise,
  fakeExpertComptable,
  fakePaperDocument,
  fakeRepresentantlegal,
} from "./fakeElement";
import { fakeProperties } from "./fakeProperties";

export const fakeCaseCurrent: CaseFragmentFragment = {
  __typename: "Case",
  id: "Q2FzZTo5NzVlMDFkYy1lZDUyLTRjMTAtYTkxNC1jMWMzMDgxYTJiOGE=",
  typeCode: "Demande",
  alertStatus: "PENDING_DECISION",
  snapshotCreation: null,
  lastScore: 10.0,
  configurableType: {
    __typename: "CaseType",
    code: "Demande",
    name: "Demande",
  },
  properties: fakeProperties("current", "2025-08-20T10:15:30.000Z", "Current", "1000"),
  elements: [
    fakeEntreprise("12345"),
    fakeExpertComptable("Current", "version", "current.version@gmail.com"),
    fakeRepresentantlegal("current", "version", "current.version@gmail.com"),
    fakePaperDocument("current"),
  ],
  blacklistedIdentifiers: fakeBlackListIdentifiers("current", "current.version@gmail.com"),
  alerts: [],
  executionResults: [],
  elementLists: [],
  adminStatus: {
    __typename: "AdminStatus",
    creation: "2023-08-02T10:00:00Z",
    lastModification: "2023-08-02T11:30:00Z",
    author: {
      __typename: "User",
      id: "user456",
      name: "Admin User",
      email: "admin@example.com",
      lastName: "User",
      firstName: "Admin",
    },
    lastModifier: {
      __typename: "User",
      id: "user789",
      name: "Moderator User",
      email: "moderator@example.com",
      lastName: "User",
      firstName: "Moderator",
    },
  },
};

export const fakeCaseCreation: CaseFragmentFragment = {
  __typename: "Case",
  id: "case2",
  typeCode: "Demande",
  alertStatus: "INITIAL",
  lastScore: 85,
  configurableType: {
    __typename: "CaseType",
    code: "Demande",
    name: "Demande",
  },
  snapshotCreation: "2025-08-19T10:15:30.000Z",
  properties: fakeProperties("creation", "2025-08-19T10:15:30.000Z", "Creation", "2000"),
  elements: [
    fakeEntreprise("4567"),
    fakeExpertComptable("Creation", "version", "creation.version@gmail.com"),
    fakeRepresentantlegal("creation", "version", "creation.version@gmail.com"),
    fakePaperDocument("creation"),
  ],
  blacklistedIdentifiers: fakeBlackListIdentifiers("creation", "creation.version@gmail.com"),
  alerts: [],
  executionResults: [],
  elementLists: [],
  adminStatus: {
    __typename: "AdminStatus",
    creation: "2023-08-02T10:00:00Z",
    lastModification: "2023-08-02T11:30:00Z",
    author: {
      __typename: "User",
      id: "user456",
      name: "Admin User",
      email: "admin@example.com",
      lastName: "User",
      firstName: "Admin",
    },
    lastModifier: {
      __typename: "User",
      id: "user789",
      name: "Moderator User",
      email: "moderator@example.com",
      lastName: "User",
      firstName: "Moderator",
    },
  },
};

export const fakeCaseValidation: CaseFragmentFragment = {
  __typename: "Case",
  id: "case3",
  typeCode: "Demande",
  alertStatus: "INITIAL",
  lastScore: 85,
  snapshotCreation: "2025-08-22T10:15:30.000Z",
  configurableType: {
    __typename: "CaseType",
    code: "Demande",
    name: "Demande",
  },
  properties: fakeProperties("validation", "2025-08-22T10:15:30.000Z", "Validation", "3000"),
  elements: [
    fakeEntreprise("8910"),
    fakeExpertComptable("validation", "version", "validation.version@gmail.com"),
    fakeRepresentantlegal("validation", "version", "validation.version@gmail.com"),
    fakePaperDocument("validation"),
  ],
  blacklistedIdentifiers: [],
  alerts: [],
  executionResults: [],
  elementLists: [],
  adminStatus: {
    __typename: "AdminStatus",
    creation: "2023-08-02T10:00:00Z",
    lastModification: "2023-08-02T11:30:00Z",
    author: {
      __typename: "User",
      id: "user456",
      name: "Admin User",
      email: "admin@example.com",
      lastName: "User",
      firstName: "Admin",
    },
    lastModifier: {
      __typename: "User",
      id: "user789",
      name: "Moderator User",
      email: "moderator@example.com",
      lastName: "User",
      firstName: "Moderator",
    },
  },
};
